let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("2YKuP")).then(() => parcelRequire('4mCP6'));